export var clipTop = function clipTop() {
  var screenWidth = document.body.clientWidth;
  var androidStatusBarHeight = window.StatusBar.actualHeight;
  return {
    marginTop: androidStatusBarHeight - screenWidth * 0.125 + 'px'
  };
};
export var clipBottom = function clipBottom() {
  var screenWidth = document.body.clientWidth;
  return {
    marginTop: 16 - screenWidth * 0.125 + 'px'
  };
};